import { logListPathFragment as _logListPathFragment } from "containers/Resources/screens/ResourcesSingle/components/RecordLogList/constants";
export const logListPathFragment = _logListPathFragment;

export const loginPath = "/login";
export const recoverPath = "/recover";
export const signOutPath = "/sign-out";
export const activatePath = "/activate";
export const confirmEmailPath = "/confirm_email";
export const resetPath = "/reset";
export const advancedSearchPathFragment = "advanced-search";
export const usersRolesPathFragment = "users-roles";

/** @deprecated Use `/workspace?advanced-search` — kept for backward-compat redirects. */
export const advancedSearchPathLegacy = "/advanced-search";
/** @deprecated Use `/workspace?users-roles` — kept for backward-compat redirects. */
export const usersRolesManagementPathLegacy = "/users-roles";

export const signedOutRoutesArray = [
    loginPath,
    recoverPath,
    signOutPath,
    activatePath,
    confirmEmailPath,
    resetPath,
];

export const bundleManagerPathFragment = "bundle-manager";
export const trashPath = "/trash";
/** @deprecated Use `/trash` — kept for backward-compat redirects. */
export const deletedPathLegacy = "/deleted";
export const executionsPathFragment = "executions";
export const settingsPathFragment = "settings";
export const storageAnalysisSubPageKey = "storage-analysis";
export const logSubPageKey = "logs";
export const canvasPathFragment = "canvas";
export const templateCanvasPathFragment = "template";
export const customObjectCanvasPathFragment = "object";
export const dashboardViewPathFragment = "view";
// Dashboard defaults to the rendered view; the config editor is reached via the
// `?edit` route flag (inverted from the historic default). See
// operator-task-fe-dashboard-default-to-view-with-edit-button.
export const dashboardEditPathFragment = "edit";

export const keyToForceUpdate = "keyToForceUpdate";

export const mapAiScreenToPath = {
    workspace_logs: logListPathFragment,
    execution_live_monitor: executionsPathFragment,
    workspace_settings: settingsPathFragment,
    bundle_manager: bundleManagerPathFragment,
    users_and_roles: usersRolesPathFragment,
    advanced_search: advancedSearchPathFragment,
    trash: trashPath,
    object_template_canvas: `${canvasPathFragment}/${templateCanvasPathFragment}`,
    custom_object_canvas: `${canvasPathFragment}/${customObjectCanvasPathFragment}`,
};

export const bootstrapUserNameKey = "bootstrapUserName";
